import { type CategoryTreeResponse, type Locale } from '@aps/contracts';
// Alohida yo'l: umumiy barrel zod'ni Mini App bundleiga tortadi (packages/contracts/src/banner-link.ts).
import { parseBannerLink } from '@aps/contracts/banner-link';
import { pickText } from '@aps/ui';
import { type Route } from '../app/navigation.js';

function findCategory(
  nodes: readonly CategoryTreeResponse[],
  id: string,
): CategoryTreeResponse | null {
  for (const node of nodes) {
    if (node.id === id) return node;
    const inChild = findCategory(node.children, id);
    if (inChild !== null) return inChild;
  }
  return null;
}

/**
 * Banner havolasi (`product:<slug>`, `category:<id>`, `catalog`, `search:<matn>`) → ekran.
 * Bo'lmasa yoki kategoriya daraxtda topilmasa `null`: banner bosilmaydigan bo'lib qoladi
 * (hech qachon bo'sh/xato ekranga olib bormaydi).
 */
export function bannerRoute(
  linkUrl: string | null,
  categories: readonly CategoryTreeResponse[],
  locale: Locale,
): Route | null {
  const link = parseBannerLink(linkUrl);
  if (link === null) return null;
  switch (link.type) {
    case 'product':
      return { name: 'product', slug: link.slug };
    case 'catalog':
      return { name: 'catalog' };
    case 'search':
      return { name: 'search', query: link.query };
    case 'category': {
      const category = findCategory(categories, link.categoryId);
      return category === null
        ? null
        : {
            name: 'catalog',
            categoryId: category.id,
            title: pickText(category.nameUz, category.nameRu, locale),
          };
    }
    default: {
      const exhaustive: never = link;
      return exhaustive;
    }
  }
}
